<template>
  <div :class="{
    'layer-checkbox': true,
    'layer-checkbox--checked': checked,
  }">
    <div class="layer-checkbox__row">
      <div :class="{'layer-checkbox__input': true, 'layer-checkbox__input--checked': checked}">
        
        <input 
          :id="label"
          title=""
          type="checkbox"
          @change="$emit('change', $event)"
          :checked="checked"
          value="checked">
      </div>
      <div
        :class="{'layer-checkbox__submodules-switcher--dark': getContrastActive}"
        class="layer-checkbox__submodules-switcher"
        v-if="hasDefaultSlotContent"
        @click.stop="submodulesToggle(tabIndex)"
      >
        <div class="layer-checkbox__submodules-switcher-inside">
          <i class="mdi mdi-chevron-down"></i>
        </div>
      </div>
      <div class="layer-checkbox__icon-wrapper">
        <div 
          class="layer-checkbox__icon"
          :class="{'layer-checkbox__icon--active': checked}"
          :style="`mask: url(${getIconUrl(icon)}) no-repeat center;mask-size: contain;`"
        ></div>
        <label :for="label" class="layer-checkbox__title" :class="{'layer-checkbox__title--active': checked}">
          <translated-text-component :translation="label" />
        </label>
      </div>
    </div>
    <div :class="{
      'layer-checkbox__submodules': true,
      'layer-checkbox__submodules--show': navActiveTab === tabIndex
    }">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
/*eslint-disable */
import { computed, defineComponent, Ref, ref, inject, useSlots } from 'vue';
import store                                   from '@/store';
import AssetIconService from '@/services/AssetIconService';

const LayerCheckbox: object = defineComponent({
  props: {
    checked: {
      type: Boolean,
      default: true,
      name: 'checked',
    },
    small: {
      type: Boolean,
      default: false,
      name: 'small',
    },
    icon: {
      type: String,
    },
    label: {
      type: String,
      default: '<BRAK DANYCH>',
      name: 'label',
    },
    tabIndex: {
      type: Number,
      default: null,
    },
  },
  name: 'LayerCheckbox',
  setup() {
    const slots = useSlots();
    const hasDefaultSlotContent = computed(() => {
      const defaultSlot = slots.default;
      return defaultSlot && defaultSlot().length > 0;
    });
    const getContrastActive: Ref<boolean> = computed((): boolean => store.getters.getContrastActive);
    const navActiveTab: Ref<number|null> = computed((): number|null => store.getters.getNavActiveTab);

    const submodulesToggle = (tabIndex: number) => {
      if (navActiveTab.value === tabIndex) {
        store.commit('setNavActiveTab', null);
      } else {
        store.commit('setNavActiveTab', tabIndex);
      }
    };

    const getIconUrl = (iconName: string) => AssetIconService.getNavStandardSvgUrl(iconName);

    return {
      getContrastActive,
      submodulesToggle,
      getIconUrl,
      navActiveTab,
      hasDefaultSlotContent,
    };
  },
});
export default LayerCheckbox;
</script>

<style scoped lang="scss">

.layer-checkbox {
  text-align: center;

  &__row {
    width: 100%;
    padding: rem(4px) rem(5px);
    display: flex;
    justify-items: flex-start;
    align-items: center;
    flex-direction: row;
    opacity: 1;
    transition: ease 0.3s;
    padding-bottom: 0;
    margin-bottom: rem(10px);
    position: relative;
    padding-right: rem(40px);
    margin-bottom: rem(15px);

    @include width-until($mobile) {
      
    }

    &:hover {
      .layer-checkbox__title {
        // text-decoration: underline;
      }
    }
  }

  &__icon-wrapper {
    display: flex;
    align-items: center;

  }

  &--checked {

    

    // .layer-checkbox__submodules {
    //   @include width-until($mobile) {
    //     margin-top: rem(14px);
    //     margin-bottom: rem(14px);
    //   }
    // }
  }

  &__input {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: transparent;
    // margin-right: rem(13px);

    input {
      opacity: 0;
      position: relative;
      width: 100%;
      height: 100%;
      z-index: 2;
      cursor: pointer;
    }

    &--checked {
      &:after {
        opacity: 1;
      }
    }
  }

  &__icon {
    width: rem(35px);
    height: rem(32px);
    text-align: center;
    margin-right: rem(7px);
    background-color: $layer-icon-off;

    &--active {
      background-color: $layer-icon-on;
    }

    @include width-until($mobile) {
      
    }

    i {
      height: 100%;
      font-size: rem(30px);
    }

    img {
      width: 100%;
      height: 100%;
    }
  }

  &__title {
    word-wrap: break-word;
    letter-spacing: rem(0.7px);
    color: $white-static;
    font-weight: 500;
    font-size: rem(12px);
    line-height: rem(16px);
    flex-grow: 1;
    word-break: break-word;

    &--active {
      color: $menu-text-active;
    }
  }

  &__label {
    // display: none;
  }

  &__submodules-switcher {
    position: absolute;
    z-index: 2;
    width: rem(22px);
    height: rem(22px);
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    right: rem(8px);
     z-index: 2;

    @include width-until($mobile) {
       
    }

    &-inside {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      width: rem(16px);
      height: rem(16px);

      i {
        line-height: 1;
        transition: ease 0.3s;
        color: $zoomer-border-color;
        font-size: rem(30px);
      }
    }

  }

  &--submodules-visible {
    &:hover {
      z-index: 2;
    }

    .layer-checkbox__submodules-switcher {
      i {
        transform: rotate(-180deg);
      }
    }
  }

  &__submodules {
    opacity: 0;
    pointer-events: none;
    transition: ease 0.6s;
    background-color: $main-bg-color;
    border-radius: 0 0 15px 15px;
    overflow: hidden;
    height: 0;
    box-shadow: 0 6px 9px 0px rgb(0 0 0 / 14%);

    &--show {
      height: auto;
      min-height: 64px;
      opacity: 1;
      pointer-events: auto;
    }
  }

  &--small {
  
      .layer-checkbox {
        &__input {

          &:before,
          &:after {
            display: none;
          }
        }

        &__submodules-switcher {
          display: none;
        }

        &__row {
          flex-direction: column;
          justify-items: flex-start;
          align-items: center;
          padding: 3px;
          margin-bottom: rem(10px);

          &:hover {
            .layer-checkbox__title {
              text-decoration: none;
            }
          }
        }

        &__icon {
          margin: 0;
          margin-bottom: rem(5px);
          width: rem(23px);
          height: rem(23px);
        }

        &__icon-wrapper {
          flex-direction: column;
          padding-left: 0;
        }

        &__title {
          font-size: 9px;
          text-align: center;
        }

        &__submodules {
          margin: 0;
        }
      }
    
  }
}
</style>
